import React from 'react';
import { render } from 'react-dom';
import ProductsList from './apps/ProductsList/ProductsList';

// Events List Application
const productsList = document.getElementById('products-app');
if (productsList) render(<ProductsList {...productsList.dataset} />, productsList);
